import { useEffect, useRef } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const dot = dotRef.current;
    if (!dot) return;

    /* ── mouse tracking ── */
    const onMove = (e) => {
      dot.style.left = e.clientX + "px";
      dot.style.top = e.clientY + "px";
    };
    window.addEventListener("mousemove", onMove);

    const label = dot.querySelector(".cursor-label");

    /* ── cursor state helpers ── */
    const expand = () => {
      dot.style.width = "36px"; dot.style.height = "36px";
      dot.style.marginLeft = "-18px"; dot.style.marginTop = "-18px";
    };
    const shrink = () => {
      dot.style.width = "7px"; dot.style.height = "7px";
      dot.style.marginLeft = "-3.5px"; dot.style.marginTop = "-3.5px";
    };
    const expandArrow = () => {
      dot.style.width = "72px"; dot.style.height = "72px";
      dot.style.marginLeft = "-36px"; dot.style.marginTop = "-36px";
      dot.style.background = "rgba(10,10,10,0.55)";
      dot.style.backdropFilter = "blur(12px)";
      dot.style.webkitBackdropFilter = "blur(12px)";
      dot.style.border = "1px solid rgba(255,255,255,0.12)";
      dot.style.mixBlendMode = "normal";
      if (label) { label.style.opacity = "1"; label.style.animation = "cursor-arrow 1s ease-in-out infinite"; }
    };
    const shrinkArrow = () => {
      shrink();
      dot.style.background = "#fff";
      dot.style.backdropFilter = "none";
      dot.style.webkitBackdropFilter = "none";
      dot.style.border = "none";
      dot.style.mixBlendMode = "difference";
      if (label) { label.style.opacity = "0"; label.style.animation = "none"; }
    };

    /* ── delegated hover — works for all elements, even those added after mount ── */
    const onOver = (e) => {
      const arrow = e.target.closest("[data-cursor='arrow']");
      if (arrow) { expandArrow(); return; }
      if (e.target.closest("a, button, .cursor-hover")) expand();
    };
    const onOut = (e) => {
      const arrow = e.target.closest("[data-cursor='arrow']");
      const toArrow = e.relatedTarget?.closest("[data-cursor='arrow']");
      const toInteractive = e.relatedTarget?.closest("a, button, .cursor-hover");
      if (arrow && !toArrow) { shrinkArrow(); return; }
      if (e.target.closest("a, button, .cursor-hover") && !toInteractive && !toArrow) shrink();
    };
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);

    const hide = () => { dot.style.opacity = "0"; };
    const show = () => { dot.style.opacity = "1"; };
    document.addEventListener("mouseleave", hide);
    document.addEventListener("mouseenter", show);

    return () => {
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseleave", hide);
      document.removeEventListener("mouseenter", show);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
    };
  }, []);

  return (
    <div
      ref={dotRef}
      aria-hidden="true"
      style={{
        position: "fixed",
        top: 0, left: 0,
        width: 7, height: 7,
        marginLeft: "-3.5px", marginTop: "-3.5px",
        borderRadius: "50%",
        background: "#fff",
        pointerEvents: "none",
        zIndex: 99999,
        mixBlendMode: "difference",
        transition: "width 0.2s ease, height 0.2s ease, margin 0.2s ease, opacity 0.2s, background 0.2s, border 0.2s",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <style>{`
        @keyframes cursor-arrow {
          0%   { transform: translate(0, 0); }
          40%  { transform: translate(4px, -4px); }
          100% { transform: translate(0, 0); }
        }
      `}</style>
      <span
        className="cursor-label"
        style={{
          opacity: 0,
          color: "#fff",
          fontSize: 20,
          lineHeight: 1,
          transition: "opacity 0.25s ease",
          pointerEvents: "none",
          userSelect: "none",
          display: "inline-block",
        }}
      >↗</span>
    </div>
  );
}
